import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'app-components';

import { ModalContextType } from '../../../contexts/modalContext';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import useCustomGrouping from '../hooks/useCustomGrouping';
import CapitalizedButton from '../components/common/CapitalizedButton';

interface IModalProps extends ModalContextType {
    groupDetails: {
        isChangePlanFlow: boolean;
        isSEPPlan: boolean;
        enablePopupForEndOfPHE: boolean;
        group: {
            inEligibleMemberList: any[];
            memberList: any[];
            groupEnrollmentId?: string | null;
            enrollmentEndDate?: string | null;
            enrollmentPriorApplicationId?: string | null;
            maxAptc?: number | null;
            maxStateSubsidy?: number | null;
            remainingAptc?: number | null;
            remainingStateSubsidy?: number | null;
            groupType?: string;
            productType?: string;
        };
    };
    caseNumber: string;
}

export default function ShopForNewPlanModal({ closeModal, groupDetails, caseNumber, openModal }: IModalProps) {
    const customGroupingState = useAppSelector(state => state.individualPortal.customGrouping);
    const { applicationId } = customGroupingState;

    const dispatch = useAppDispatch();
    const { shopForNewPlan } = useCustomGrouping({ dispatch });

    function onClose(e) {
        e?.preventDefault();
        closeModal('shopForNewPlan');
    }

    function onContinue() {
        shopForNewPlan(groupDetails, applicationId, caseNumber, { openModal });
    }

    return (
        <Modal id="shopForNewPlanModal">
            <Modal.Header
                id="shopForNewPlanModalHeader"
                titleId="customGrouping.customGrouping"
                onHide={onClose}
            />
            <Modal.Body id="disenrollIneligibleGroupModalBody">
                <p>
                    <FormattedMessage id="customGrouping.shopForNewPlanMsg" />
                </p>
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton 
                    id="shopForNewPlanModalCancelButton" 
                    onClickHandler={onClose} 
                    variant="secondary" 
                    labelId="button.cancel" 
                />
                <CapitalizedButton
                    id="shopForNewPlanModalShopForPlansButton"
                    onClickHandler={onContinue}
                    variant="primary"
                    labelId="customGrouping.shopForPlans"
                    leftMargin={true}
                />
            </Modal.Controls>
        </Modal>
    );
}
